module.exports = __webpack_public_path__ + "Roboto-BlackItalic.1f37c7545ae9f63d2279.svg";


//////////////////
// WEBPACK FOOTER
// /app/~/roboto-fontface/fonts/Roboto/Roboto-BlackItalic.svg
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-BlackItalic.svg
// module chunks = 16